import React from 'react'

import Spinner from '../../spinner/Spinner'
import { StepHeader } from '../../step-header/StepHeader'

import LightningButton from 'components/new-buttons/LightningButton'

interface StepOneProps {
  loading: boolean
  errorMessage: string
  getIframe: () => Promise<void>
}

const StepOne = (props: StepOneProps) => {
  const { loading, errorMessage, getIframe } = props
  return (
    <>
      <StepHeader
        title="Undirritun"
        text="Síðasta skrefið er rafræn undirritun og að því loknu sjáum við um framhaldið."
      />

      {loading ? (
        <Spinner centered text="Sæki skjal til undirritunar" />
      ) : (
        <LightningButton
          text=" Hefja undirritun"
          onClick={getIframe}
          disabled={loading}
          link={undefined}
        />
      )}

      {errorMessage && !loading && <h4>{errorMessage}</h4>}
    </>
  )
}

export default StepOne
